import React, { useEffect, useState } from "react";
import localizationService from "../../services/localization-service.js";
import { useSelector } from "react-redux";

const SmsUnsubscribeModal = ({ isOpen, onClose, onConfirm }) => {
  const selectedlang = useSelector((state) => state.account.lang);
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 1300) {
      setIsDesktopResolution(false);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div
          className="px-6 py-4 border-b border-gray-200"
          style={{ position: "relative" }}
        >
          <h3 className="text-lg font-medium text-gray-900">
            {localizationService.getLocalizationValue(
              "unsubscribeToSMSModalTitle",
              selectedlang,
            )}
          </h3>
          <i
            className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
            onClick={onClose}
          ></i>
        </div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500 mb-3">
            {localizationService.getLocalizationValue(
              "unsubscribePartOne",
              selectedlang,
            )}
          </p>
          <p className="text-sm text-gray-500 mb-3">
            {localizationService.getLocalizationValue(
              "unsubscribePartTwo",
              selectedlang,
            )}
          </p>
          <p className="text-sm text-gray-500">
            {localizationService.getLocalizationValue(
              "unsubscribeContinue",
              selectedlang,
            )}
          </p>
        </div>
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={onConfirm}
            className="inline-flex w-[50%] justify-center items-center px-4 py-2 border border-[#7d8a1f] text-sm font-medium rounded-md text-white bg-[#9aa82d] hover:bg-[#7d8a1f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {localizationService.getLocalizationValue("yes", selectedlang)}
          </button>
          <button
            onClick={onClose}
            className="inline-flex w-[50%] justify-center items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-[#ffffff] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
          >
            {localizationService.getLocalizationValue("no", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsUnsubscribeModal;
